//@ helpers
const actionTypes = require('constants/actionTypes');

//@ vendors
const { Promise } = require('es6-promise');
const moment = require('moment');

//@ actions
const signaturePatternActions = require('actions/signaturePattern');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { isSepa, getSepaTypeTransfers } = require('utilities/transfersHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ constants
const { DATE_FORMAT_API, API_ENTERPRISE_NUMBER } = require('constants/index');

const setIbanOnCountryChange = (ibanIsDirty) => ({
    type: actionTypes.ADD_BENEFICIARY_SET_IBAN_ON_COUNTRY_CHANGE,
    ibanIsDirty
});

function reset() {
    return {
        type: actionTypes.ADD_BENEFICIARY_RESET
    };
}

function setVisibleStep(step) {
    return {
        type: actionTypes.ADD_BENEFICIARY_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function setBeneficiaryName(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_NAME,
        payload: {
            name: value
        }
    };
}

function setBeneficiaryAddress(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_ADDRESS,
        payload: {
            address: value
        }
    };
}

function setBeneficiaryCity(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_CITY,
        payload: {
            city: value
        }
    };
}

function setBeneficiaryAlias(alias, isValid) {
    return {
        type: actionTypes.ADD_BENEFICIARY_ALIAS,
        payload: {
            alias,
            isValid
        }
    };
}

function setBeneficiaryIban(iban, isValid) {
    return {
        type: actionTypes.ADD_BENEFICIARY_IBAN,
        payload: {
            iban,
            ibanIsDirty: true,
            ibanIsValid: isValid
        }
    };
}

function setBeneficiaryBic(bic, isValid) {
    return {
        type: actionTypes.ADD_BENEFICIARY_BIC,
        payload: {
            bic,
            isValid
        }
    };
}

function setBeneficiaryAccountNumber(value, isValid) {
    return {
        type: actionTypes.ADD_BENEFICIARY_ACCOUNT_NUMBER,
        payload: {
            isValid,
            accountNumber: value
        }
    };
}

function handleBeneficiaryCountry(country) {
    return {
        type: actionTypes.ADD_BENEFICIARY_COUNTRY,
        payload: {
            country
        }
    };
}

function handleBeneficiaryBankOption(option) {
    return {
        type: actionTypes.ADD_BENEFICIARY_BANK_OPTION,
        payload: {
            option
        }
    };
}

function setBeneficiaryBankName(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_BANK_NAME,
        payload: {
            name: value
        }
    };
}

function setBeneficiaryBankAddress(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_BANK_ADDRESS,
        payload: {
            address: value
        }
    };
}

function setBeneficiaryBankCity(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_BANK_CITY,
        payload: {
            city: value
        }
    };
}

function handleCurrency(currency) {
    return {
        type: actionTypes.ADD_BENEFICIARY_CURRENCY,
        payload: {
            currency: currency.value
        }
    };
}

function setWillLeave() {
    return {
        type: actionTypes.ADD_BENEFICIARY_WILL_LEAVE
    };
}

function setWillCancel(value) {
    return {
        type: actionTypes.ADD_BENEFICIARY_WILL_CANCEL,
        payload: {
            value
        }
    };
}

function validateUIStep(step) {
    return {
        type: actionTypes.ADD_BENEFICIARY_VALIDATE_UI_STEP,
        payload: {
            step
        }
    };
}

const validationRequest = () => ({
    type: actionTypes.ADD_BENEFICIARY_VALIDATE_STEP_REQUEST
});

const validationSuccess = (step, data) => ({
    type: actionTypes.ADD_BENEFICIARY_VALIDATE_STEP_SUCCESS,
    payload: {
        data,
        step
    }
});

const validationFailure = error => ({
    type: actionTypes.ADD_BENEFICIARY_VALIDATE_STEP_FAILURE,
    payload: {
        error
    }
});

const validateWithAPI = step => (dispatch, getState) => {
    const immAddBeneficiary = getState().addBeneficiary.getIn(['steps', 0]);
    const valid = immAddBeneficiary.get('valid');

    if (valid) {
        const isSepaBeneficiary = isSepa(
            immAddBeneficiary.get('country'),
            immAddBeneficiary.get('currency')
        );

        if (isSepaBeneficiary) {
            const iban = immAddBeneficiary.get('iban');

            const requestData = {
                header: {
                    version: 2
                },
                query: {
                    alias: immAddBeneficiary.get('alias'),
                    cuentaIBAN: {
                        codbban: iban.slice(4),
                        digitodecontrol: iban.slice(2, 4),
                        pais: iban.slice(0, 2)
                    },
                    moneda: immAddBeneficiary.get('currency'),
                    tipoDestinatario: '01',
                    tipoOperacion: 'A'
                }
            };

            dispatch(validationRequest());
            return APIPost(dispatch, apiURLBuilder.getURL('addBeneficiaryValidation'), requestData)
                .then(response => dispatch(validationSuccess(step, response)))
                .catch(response => {
                    if (!!response.error) {
                        scrollToTop();

                        if (typeof response.error.description === 'string') {
                            let delimiterIndex = response.error.description.indexOf('&&&');
                            if (delimiterIndex >= 0) {
                                response.error.description = response.error.description.substring(delimiterIndex + 3); //Cut &&& from response
                            } else {
                                delimiterIndex = response.error.description.indexOf('&&');
                                if (delimiterIndex >= 0) {
                                    response.error.description = response.error.description.substring(delimiterIndex + 2); //Cut && from response
                                }
                            }
                        }

                        return dispatch(validationFailure(response.error.description));
                    } else {
                        throw response;
                    }
                });
        } else {
            dispatch(validationSuccess(step, {}));
            return;
        }
    } else {
        scrollToTop();
    }
};

const validateStep = step => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateWithAPI(step));
};

function postBeneficiarySuccess(data) {
    return {
        type: actionTypes.ADD_BENEFICIARY_REQUEST_SUCCESS,
        payload: {
            data
        }
    };
}

function postBeneficiaryRequest() {
    return {
        type: actionTypes.ADD_BENEFICIARY_REQUEST_REQUEST
    };
}

function postBeneficiaryFailure(error) {
    return {
        type: actionTypes.ADD_BENEFICIARY_REQUEST_FAILURE,
        payload: {
            error
        }
    };
}

function setBeneficiary(immBeneficiary) {
    return {
        type: actionTypes.ADD_BENEFICIARY_FILL_FORM,
        payload: {
            beneficiaryId: immBeneficiary.get('id'),
            name: immBeneficiary.get('name'),
            alias: immBeneficiary.get('alias'),
            iban: immBeneficiary.get('iban'),
            accountNumber: immBeneficiary.get('accountNumber'),
            bic: immBeneficiary.get('bic'),
            address: immBeneficiary.get('address'),
            city: immBeneficiary.get('city'),
            currency: immBeneficiary.get('currency'),
            country: immBeneficiary.get('country'),
            bankName: immBeneficiary.get('bankName'),
            bankAddress: immBeneficiary.get('bankAddress'),
            bankCity: immBeneficiary.get('bankCity'),
            sepaTypeBeforeEdit: getSepaTypeTransfers(
                immBeneficiary.get('country'),
                immBeneficiary.get('currency'),
                immBeneficiary.get('iban')
            )
        }
    };
}

function setBeneficiaryFromTransfer(immBeneficiary, sepaTypeBeforeEdit = '', beneficiaryId = '') {
    return {
        type: actionTypes.ADD_BENEFICIARY_FILL_FORM_FROM_TRANSFER,
        payload: {
            beneficiaryId: beneficiaryId,
            sepaTypeBeforeEdit: sepaTypeBeforeEdit,
            name: immBeneficiary.get('name'),
            alias: immBeneficiary.get('alias'),
            iban: immBeneficiary.get('iban'),
            accountNumber: immBeneficiary.get('accountNumber'),
            bic: immBeneficiary.get('bic'),
            address: immBeneficiary.get('address'),
            city: immBeneficiary.get('city'),
            currency: immBeneficiary.get('currency'),
            country: immBeneficiary.get('country'),
            bankName: immBeneficiary.get('bankName'),
            bankAddress: immBeneficiary.get('bankAddress'),
            bankCity: immBeneficiary.get('bankCity')
        }
    };
}

function resetLoadFromTransfer() {
    return {
        type: actionTypes.ADD_BENEFICIARY_RESET_LOAD_FROM_TRANSFER
    };
}

function toggleIbanModal() {
    return {
        type: actionTypes.TOGGLE_IBAN_MODAL
    };
}

const fillBeneficiaryForm = beneficiaryId => (dispatch, getState) => {
    const immBeneficiary = getState().beneficiaries.get('byId').get(beneficiaryId);
    dispatch(setBeneficiary(immBeneficiary));
};

const postBeneficiaryCallback = (dispatch, getState, dataToken) => {
    const immBeneficiary = getState().addBeneficiary.getIn(['steps', 0]);

    const isSepaBeneficiary = isSepa(
        immBeneficiary.get('country'),
        immBeneficiary.get('currency')
    );

    const requestData = {
        header: {
            version: 2
        },
        query: {
            dataToken,
            alias: immBeneficiary.get('alias'),
            cuentaIbanBeneficiario: isSepaBeneficiary
                ? immBeneficiary.get('iban')
                : immBeneficiary.get('accountNumber'),
            nombreBeneficiario: immBeneficiary.get('name'),
            fechaOrden: moment().format(DATE_FORMAT_API),
            importe: {
                divisa: immBeneficiary.get('currency'),
                importe: 1
            },
            paisDestino: immBeneficiary.get('country'),
            tipoActuante: {
                codtipodeactuante: 'FB'
            },
            tipoCuenta: isSepaBeneficiary ? 'A' : immBeneficiary.get('bic') ? 'C' : 'D',
            tipoDestinatario: isSepaBeneficiary ? '01' : '02',
            tipoSepa: getSepaTypeTransfers(
                immBeneficiary.get('country'),
                immBeneficiary.get('currency'),
                immBeneficiary.get('iban')
            ),
            indAltaPrealta: 'A'
        }
    };

    if (!isSepaBeneficiary) {
        requestData.query.bicBancoBeneficiario = immBeneficiary.get('bic') || undefined;
        requestData.query.nombreBancoDestino = immBeneficiary.get('bankName') || undefined;
        requestData.query.direccionBeneficiario = immBeneficiary.get('address') || undefined;
        requestData.query.direccionBanco = immBeneficiary.get('bankAddress') || undefined;
        requestData.query.localidadBeneficiario = immBeneficiary.get('city') || undefined;
        requestData.query.localidadBanco = immBeneficiary.get('bankCity') || undefined;
    }

    dispatch(postBeneficiaryRequest());
    return APIPost({dispatch, endpoint:'addBeneficiaryConfirmation', params: requestData})
        .then(
            (response) => dispatch(postBeneficiarySuccess(response)),
            (response) => {
                if (response.error) {
                    dispatch(postBeneficiaryFailure(response.error));
                }
                throw response;//This is needed to catch the error in transferActions/postTransfer
            }
    );
};

const postBeneficiary = () => (dispatch, getState) => {
    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, postBeneficiaryCallback);
    });
};

const addBeneficiaryFromTransferForm = (dataToken) => (dispatch, getState) => {
    const immBeneficiary = getState().transfer.getIn(['steps', 0, 'beneficiary', 'new']);
    dispatch(setBeneficiaryFromTransfer(immBeneficiary));
    return postBeneficiaryCallback(dispatch, getState, dataToken);
};

const postEditBeneficiaryCallback = (dispatch, getState, dataToken) => {
    const immBeneficiary = getState().addBeneficiary.getIn(['steps', 0]);
    const beneficiaryId = immBeneficiary.get('beneficiaryId');
    const beneficiaryType = getState().beneficiaries.getIn([
        'byId',
        beneficiaryId,
        'extra',
        'type'
    ]);
    const isSepaBeneficiary = isSepa(
        immBeneficiary.get('country'),
        immBeneficiary.get('currency')
    );
    const sepaType = getSepaTypeTransfers(immBeneficiary.get('country'), immBeneficiary.get('currency'), immBeneficiary.get('iban'));
    const sepaTypeParam = `?tipoSepa=${sepaType}`;

    const requestData = {
        header: {
            version: 2
        },
        query: {
            dataToken,
            alias: immBeneficiary.get('alias'),
            fechaOrden: moment().format(DATE_FORMAT_API),
            idActuante: {
                tipodeactuante: {
                    empresa: API_ENTERPRISE_NUMBER,
                    codtipodeactuante: 'FB'
                },
                numerodeactuante: 0
            },
            importe: {
                divisa: immBeneficiary.get('currency'),
                importe: 1
            },
            nombreBeneficiario: immBeneficiary.get('name'),
            pais: immBeneficiary.get('country'),
            tipoCuenta: isSepaBeneficiary ? 'A' : immBeneficiary.get('bic') ? 'C' : 'D',
            tipoDestinatario: beneficiaryType,
            tipoSepaAntes: immBeneficiary.get('sepaTypeBeforeEdit'),
            tipoSepaDespues: sepaType,
            indAltaPrealta: 'A',
            cuentaNoSepa: immBeneficiary.get('accountNumber') || undefined,
            bicEntidadExterna: immBeneficiary.get('bic') || undefined,
            direccionBeneficiarioNoSepa: immBeneficiary.get('address') || undefined,
            direccionEntidadExterna: immBeneficiary.get('bankAddress') || undefined,
            localidadBeneficiarioNoSepa: immBeneficiary.get('city') || undefined,
            localidadEntidadExterna: immBeneficiary.get('bankCity') || undefined,
            entidadEnTexto: immBeneficiary.get('bankName') || undefined
        }
    };

    if (isSepaBeneficiary) {
        const iban = immBeneficiary.get('iban');
        requestData.query.cuentaIban = {
            codbban: iban.slice(4),
            digitodecontrol: iban.slice(2, 4),
            pais: iban.slice(0, 2)
        };
    }

    dispatch(postBeneficiaryRequest());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL('editBeneficiaryConfirmation') + sepaTypeParam,
        requestData
    ).then(
        function(response) {
            dispatch(postBeneficiarySuccess(response));
        },
        function(response) {
            if (response.error) {
                dispatch(postBeneficiaryFailure(response));
            }
            throw response;//This is needed to catch the error in transferActions/postTransfer
        }
    );
};

const postEditBeneficiary = () => (dispatch, getState)  => {
    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, postEditBeneficiaryCallback);
    });
};

const editBeneficiaryFromTransferForm = (dataToken, sepaTypeBeforeEdit, beneficiaryId) => (dispatch, getState) => {
    const immBeneficiary = getState().transfer.getIn(['steps', 0, 'beneficiary', 'new']);
    dispatch(setBeneficiaryFromTransfer(immBeneficiary, sepaTypeBeforeEdit, beneficiaryId));
    return postEditBeneficiaryCallback(dispatch, getState, dataToken);
};

const validateEditWithAPI = step => (dispatch, getState) => {
    const immAddBeneficiary = getState().addBeneficiary.getIn(['steps', 0]);
    const beneficiaryId = immAddBeneficiary.get('beneficiaryId');
    const valid = immAddBeneficiary.get('valid');

    if (valid) {
        const isSepaBeneficiary = isSepa(
            immAddBeneficiary.get('country'),
            immAddBeneficiary.get('currency')
        );

        if (isSepaBeneficiary) {
            const immBeneficiary = getState().beneficiaries.getIn(['byId', beneficiaryId]);
            const iban = immAddBeneficiary.get('iban');

            const requestData = {
                header: {
                    version: 2
                },
                query: {
                    alias: immAddBeneficiary.get('alias'),
                    codiban: {
                        codbban: iban.slice(4),
                        digitodecontrol: iban.slice(2, 4),
                        pais: iban.slice(0, 2)
                    },
                    contratoPartenon: {
                        numerodecontrato: immBeneficiary.getIn(['extra', 'contract', 'number']),
                        producto: immBeneficiary.getIn(['extra', 'contract', 'product'])
                    },
                    cuentaNacSepa: {
                        detallecontratolocal: iban.slice(4),
                        tipocontratolocal: '60'
                    },
                    pais: immAddBeneficiary.get('country'),
                    moneda: immAddBeneficiary.get('currency'),
                    tipoDestinatario: '01',
                    tipoOperacion: 'M'
                }
            };

            dispatch(validationRequest());
            return APIPost(dispatch, apiURLBuilder.getURL('editBeneficiaryValidation'), requestData)
                .then(response => dispatch(validationSuccess(step, response)))
                .catch(response => {
                    if (!!response.error) {
                        scrollToTop();

                        if (typeof response.error.description === 'string') {
                            let delimiterIndex = response.error.description.indexOf('&&&');
                            if (delimiterIndex >= 0) {
                                response.error.description = response.error.description.substring(delimiterIndex + 3); //Cut &&& from response
                            } else {
                                delimiterIndex = response.error.description.indexOf('&&');
                                if (delimiterIndex >= 0) {
                                    response.error.description = response.error.description.substring(delimiterIndex + 2); //Cut && from response
                                }
                            }
                        }

                        return dispatch(validationFailure(response.error.description));
                    } else {
                        throw response;
                    }
                });
        } else {
            dispatch(validationSuccess(step, {}));
            return;
        }
    } else {
        scrollToTop();
    }
};

const validateEditStep = step => dispatch => {
    dispatch(validateUIStep(step));
    dispatch(validateEditWithAPI(step));
};

module.exports = {
    reset,
    setVisibleStep,
    setBeneficiaryName,
    setBeneficiaryAddress,
    setBeneficiaryCity,
    setBeneficiaryAlias,
    handleBeneficiaryCountry,
    setBeneficiaryIban,
    setBeneficiaryBic,
    handleBeneficiaryBankOption,
    setBeneficiaryBankName,
    setBeneficiaryBankAddress,
    setBeneficiaryBankCity,
    setBeneficiaryAccountNumber,
    handleCurrency,
    fillBeneficiaryForm,
    addBeneficiaryFromTransferForm,
    editBeneficiaryFromTransferForm,
    resetLoadFromTransfer,
    setWillLeave,
    setWillCancel,
    postBeneficiary,
    postEditBeneficiary,
    validateStep,
    validateEditStep,
    toggleIbanModal,
    setIbanOnCountryChange
};
